import parse, { type DOMNode, domToReact, Element, type HTMLReactParserOptions } from "html-react-parser";
import Link from "next/link";
import type { JSX } from "react";

export type ReplacementsMap = Record<string, (domNode: Element, options: HTMLReactParserOptions) => JSX.Element | Element | null>;

interface HtmlParserProps {
  data?: string;
  redefine?: ReplacementsMap;
}

export const HtmlParser = (props: HtmlParserProps) => {
  const { data, redefine } = props;

  let replacementsMap: ReplacementsMap = {};
  replacementsMap.a = (domNode: any, options: HTMLReactParserOptions) => {
    const href = domNode.attribs.href;

    return (
      <Link href={href} className="text-primary-600 font-semibold">
        {domToReact(domNode.children, options)}
      </Link>
    );
  };
  replacementsMap.ul = (domNode: any, options: HTMLReactParserOptions) => {
    return <ul className="pl-4 list-disc">{domToReact(domNode.children, options)}</ul>;
  };
  replacementsMap.ol = (domNode: any, options: HTMLReactParserOptions) => {
    return <ol className="pl-4 list-decimal">{domToReact(domNode.children, options)}</ol>;
  };
  replacementsMap.h2 = (domNode: any, options: HTMLReactParserOptions) => {
    return <h2 className="my-6 font-bold text-3xl">{domToReact(domNode.children, options)}</h2>;
  };
  replacementsMap.h3 = (domNode: any, options: HTMLReactParserOptions) => {
    return <h3 className="my-6 font-bold text-2xl">{domToReact(domNode.children, options)}</h3>;
  };
  replacementsMap.h4 = (domNode: any, options: HTMLReactParserOptions) => {
    return <h4 className="my-6 font-bold text-xl">{domToReact(domNode.children, options)}</h4>;
  };
  replacementsMap.h5 = (domNode: any, options: HTMLReactParserOptions) => {
    return <h5 className="my-6 font-bold text-lg">{domToReact(domNode.children, options)}</h5>;
  };

  replacementsMap = {
    ...replacementsMap,
    ...redefine,
  };

  const options: HTMLReactParserOptions = {
    replace: (domNode: DOMNode) => {
      if (domNode instanceof Element) {
        if (replacementsMap[domNode.name]) {
          return replacementsMap[domNode.name](domNode, options);
        }
        return domNode;
      }
    },
  };

  if (!data) {
    return null;
  }

  return <>{parse(data, options)}</>;
};
